module.exports = __webpack_public_path__ + "img/1527499196.a024bf0b.jpg";